import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import { Cookies } from 'react-cookie';
import axios from 'axios';

const initialState = {
    data: [],
    users: [],
    pages: 0,
    total: 0,
    current: 0,
    error: null,
    sidebar: true,
    insurance: {},
    loading: false,
    userinsurances: [],
}

export const InsuranceCompanyCreate = createAsyncThunk('InsuranceCompanyCreate', async ({ data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const cookies = new Cookies()
        const response = await axios.post(`${BASEURL}/admin/insurance/company/create`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${cookies.get('auth')}`,
                }
            })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    navigate('/admin/insurance-list');
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const InsuranceCompanyList = createAsyncThunk('InsuranceCompanyList', async ({ data, navigate, page, country, text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/insurance/company/list?page=${page}&country=${country}&text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const InsuranceCompanyVerify = createAsyncThunk('InsuranceCompanyVerify', async ({ id, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/insurance/company/verify/${id}`,
            { headers: headers() })
            .then((res) => {
                dispatch(InsuranceCompanyList({}))
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const InsuranceCompanyDelete = createAsyncThunk('InsuranceCompanyDelete', async ({ id, page, country, text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/admin/insurance/company/delete/${id}`,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(InsuranceCompanyList({ page, country, text }))
                }
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const SingleInsuranceCompany = createAsyncThunk('SingleInsuranceCompany', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/insurance/company/${id}`,
            { headers: headers() })
            .then((res) => {
                return res.data
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const UpdateInsuranceCompany = createAsyncThunk('UpdateInsuranceCompany', async ({ id, data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const cookies = new Cookies()
        const response = await axios.put(`${BASEURL}/admin/insurance/update/${id}`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${cookies.get('auth')}`,
                }
            })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    navigate('/admin/insurance-list');
                }
                return res.data
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const banCompanyReq = createAsyncThunk('banCompanyReq', async ({ page, id, data, country, text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/admin/company/ban/${id}`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(InsuranceCompanyList({ page, country, text }))
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const InsuranceList = createAsyncThunk('InsuranceList', async ({ role }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/insurance/form/list/${role}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const InsuranceApprove = createAsyncThunk('InsuranceApprove', async ({ id, role, data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/insurance/form/approve/${id}`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(InsuranceList({ role: role }))

                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const InsuranceDelete = createAsyncThunk('InsuranceDelete', async ({ role, id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/insurance/form/delete/${id}`,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(InsuranceList({ role: role }))
                }
                return res?.data
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const InsuranceComUser = createAsyncThunk('InsuranceComUser', async ({ }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/insurance/form/users`,
            { headers: headers() })
            .then((res) => {
                return res?.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const InsuranceSlice = createSlice({
    name: 'insuranceSlice',
    initialState: initialState,
    reducers: {
        isSide: (state, action) => {
            state.sidebar = action.payload
            return state
        },
    },
    extraReducers: (builder) => {
        builder.addCase(InsuranceCompanyList.pending, (state, action) => {
            state.loading = true
            state.pages = 0
            state.total = 0
            state.current = 1
            state.data = []
            return state
        })
        builder.addCase(InsuranceCompanyList.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload.data?.insurances
            state.current = action.payload.data?.current
            state.pages = action.payload.data?.pages
            state.total = action.payload.data?.total
            return state
        })
        builder.addCase(InsuranceCompanyList.rejected, (state, action) => {
            state.loading = false
            state.pages = 0
            state.total = 0
            state.current = 1
            state.data = []
            state.error = 'Error occured'
        })
        builder.addCase(InsuranceList.pending, (state, action) => {
            state.loading = true
            state.userinsurances = []
            return state
        })
        builder.addCase(InsuranceList.fulfilled, (state, action) => {
            state.loading = false
            state.userinsurances = action.payload.data
            return state
        })
        builder.addCase(InsuranceList.rejected, (state, action) => {
            state.loading = false
            state.userinsurances = []
            state.error = 'Error occured'
        })
        builder.addCase(InsuranceComUser.pending, (state, action) => {
            state.loading = true
            state.users = []
            return state
        })
        builder.addCase(InsuranceComUser.fulfilled, (state, action) => {
            state.loading = false
            state.users = action.payload.data
            return state
        })
        builder.addCase(InsuranceComUser.rejected, (state, action) => {
            state.loading = false
            state.users = []
            state.error = 'Error occured'
        })
        builder.addCase(InsuranceCompanyCreate.pending, (state, action) => {
            state.loading = true
            return state
        })
        builder.addCase(InsuranceCompanyCreate.fulfilled, (state, action) => {
            state.loading = false
            return state
        })
        builder.addCase(InsuranceCompanyCreate.rejected, (state, action) => {
            state.loading = false
            state.error = 'Error occured'
        })
        builder.addCase(SingleInsuranceCompany.pending, (state, action) => {
            state.loading = true
            state.insurance = {}
            return state
        })
        builder.addCase(SingleInsuranceCompany.fulfilled, (state, action) => {
            state.loading = false
            state.insurance = action.payload.data
            return state
        })
        builder.addCase(SingleInsuranceCompany.rejected, (state, action) => {
            state.loading = false
            state.data = {}
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export const { isSide } = InsuranceSlice.actions
export default InsuranceSlice.reducer